import { render, staticRenderFns } from "./observar.vue?vue&type=template&id=3089bb12&scoped=true&"
import script from "./observar.vue?vue&type=script&lang=ts&"
export * from "./observar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089bb12",
  null
  
)

export default component.exports